import { Flex, Table, Typography } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getServiceProviderSubscriptionPlanHistoryAction } from "../../../../../../redux/services/service-provider-subscriptions/serviceProviderSubscriptionsServices";
import Spinner from "../../../../../common/spinner/Spinner";
import { dateObjToDispViewDate, downloadUrl, timeObjToDispViewTimeWithSuffix } from "../../../../../../utils/utils";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import useDebounce from "../../../../../../hooks/useDebounce";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();
const SubscriptionsPlanHistory = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { serviceProviderSubscriptionPlanHistory } = useSelector(
    (state) => state.serviceProviderSubscriptions
  );
  const [searchValue] = useState("");
  const { debouncedValue: debouncedSearchValue } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: serviceProviderSubscriptionPlanHistory?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue,
      type:"main"
    }
    dispatch(getServiceProviderSubscriptionPlanHistoryAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, debouncedSearchValue]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.addOns.type"),
        dataIndex: "type",
        key: "type",
        render: (_, record) => <>{`${record?.type || "-"}`}</>,
      },
      {
        title: t("Modules.addOns.expiryDate"),
        dataIndex: "expire_date_time",
        key: "expire_date_time",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.expire_date_time, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Modules.addOns.duration"),
        dataIndex: "duration",
        render: (_, record) => (
          <>{`${record?.duration} ${record?.duration_unit}`}</>
        ),
      },
      {
        title: t("CommonUtils.subtotal"),
        dataIndex: "subtotal_amount",
        key: "subtotal_amount",
        render: (_, record) => <>{`${record?.subtotal_amount?.toFixed(2)} ${record?.currency}`}</>,
      },
      {
        title: t("CommonUtils.tax"),
        dataIndex: "tax_amount",
        key: "tax_amount",
        render: (_, record) => <>{`${record?.tax_amount?.toFixed(2)} ${record?.currency}`}</>,
      },
      {
        title: t("CommonUtils.total"),
        dataIndex: "total_amount",
        key: "total_amount",
        render: (_, record) => <>{`${record?.total_amount?.toFixed(2)} ${record?.currency}`}</>,
      },
      {
        title:  t("Modules.addOns.defaultLogin"),
        dataIndex: "default_logins",
        key: "default_logins",
        render: (_, record) => <>{`${record?.default_logins}`}</>,
      },
      // {
      //   title: t("Modules.addOns.addOnLogins"),
      //   dataIndex: "addon_logins",
      //   key: "addon_logins",
      //   render: (_, record) => <>{`${record?.addon_logins}`}</>,
      // },
      // {
      //   title:  t("Modules.addOns.totalLogin"),
      //   dataIndex: "number_of_total_logins",
      //   key: "number_of_total_logins",
      //   render: (_, record) => <>{`${record?.number_of_total_logins}`}</>,
      // },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        render: (_, record) => (
          <p>{`${dateObjToDispViewDate(record?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
        ),
      },
      {
        title: t("viewPdf"),
        key: "viewPdf",
        dataIndex: "viewPdf",
        align: "center",
        render: (_, record) => {
          return (
            <>
              {
                <Typography.Link
                  onClick={(e) => handleViewPdfDetails(e, record)}
                >
                  {t("view")}
                </Typography.Link>
              }
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleViewPdfDetails = (e, row) => {
    if (
      row?.invoice_url &&
      row?.invoice_url !== "" &&
      row?.invoice_url !== null &&
      row?.invoice_url !== undefined
    ) {
      downloadUrl(row?.invoice_url);
    } 
  }

  return (
    <div className="servicesListContainer">
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Title level={2}>{t("Modules.addOns.subsHistory")}</Title>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={serviceProviderSubscriptionPlanHistory?.data}
            columns={columns}
            pagination = {paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default SubscriptionsPlanHistory;
